import { computed, Directive, input } from '@angular/core';
import { hlm } from '@spartan-ng/helm/utils';
import type { ClassValue } from 'clsx';

@Directive({
  selector: '[hlmDialogFooter],hlm-dialog-footer',
  host: {
    'data-slot': 'dialog-footer',
    '[class]': '_computedClass()',
  },
})
export class HlmDialogFooter {
  public readonly userClass = input<ClassValue>('', { alias: 'class' });
  protected readonly _computedClass = computed(() =>
    hlm('flex flex-col-reverse sm:flex-row border-t border-stroke-neutral-light', this.userClass()),
  );
}
